import { ActionType, ComponentType } from '../../enums';

export interface CreateTabClickEventPayloadOptions {
  itemName: string;
  itemText: string;
  pageType: string;
  tabIndex: number;
  variant: string;
}

export interface CreateTabClickEventPayloadReturn {
  event_data: {
    action: ActionType;
    component_type: ComponentType;
    component_variant: string;
    index: number;
    item_name: string;
    item_text: string;
    page_type: string;
  };
}

export const createTabClickEventPayload = ({
  itemName,
  itemText,
  pageType,
  tabIndex,
  variant,
}: CreateTabClickEventPayloadOptions): CreateTabClickEventPayloadReturn => {
  return {
    event_data: {
      action: ActionType.CLICK,
      component_type: ComponentType.TAB,
      component_variant: variant,
      index: tabIndex,
      item_name: itemName,
      item_text: itemText,
      page_type: pageType,
    },
  };
};
